import type { App } from "@butler/server";
import { treaty } from "@elysiajs/eden";
export const api = treaty<App>("http://localhost:6969");
